module.exports = __webpack_public_path__ + "img/gcariboo.fff54e5d.png";